import Table from './Table';

import classes from './MainTable.module.css';

export default Table;

export { classes as TableClasses };
